// Clinic Configuration for Dentist In Concord
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Dentist in Bloomingdale",
  clinicId: "dentistinbloomingdale",
  clinicUrl: "https://www.dentistinbloomingdaleil.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=dentistinbloomingdale&agentId=ace803c6-088b-4d9d-9099-04ce9caf320a",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/dentistinbloomingdale/voice",

  // Contact Information
  phoneNumber: "6306861328",
  phoneNumberRaw: "+16306861328", // For tel: and sms: links
  email: "dentalcare@dentistinbloomingdaleil.com",

  // Location
  address: "366 W Army Trail Rd #310a, Bloomingdale , IL 60108, United States",
  addressShort: "366 W Army Trail Rd #310a, Bloomingdale , IL 60108, USA",
  city: "Bloomingdale",
  hcity: "Bloomingdale",
  state: "Illinois",
  stateShortForm: "IL",
  PostalCode: "60108",

  // Map Links
  mapUrl: "https://maps.app.goo.gl/WvzNh6NsvtPbnG7g6",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d18085.761392503988!2d-88.14880768916015!3d41.9375743!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880fab0b81d48b75%3A0x8784419cb9fac87d!2sDentist%20in%20Bloomingdale!5e1!3m2!1sen!2sin!4v1759924584425!5m2!1sen!2sin',
  iframeTitle: "Dentist In Bloomingdale",

  //membership
  membership: "https://member.kleer.com/?slug=PX8B",

  // Sunbit
  sunbitUrl: "https://www.dentistinbloomingdaleil.com/patient-portal",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/dentist-in-bloomingdale?utm_source=practice&utm_medium=email&m=65962",


  // Analytics
  clarityProjectId: "prdid5gc91",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/dentistinbloomingdale",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/dentistinbloomingdale",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/dentistinbloomingdale",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://dentistinbloomingdaleil.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/DentistinBloomingDale",
    instagram: "https://www.instagram.com/stories/dentistinbloomingdale/",
    twitter: "https://x.com/DentistBlooming",
    linkedin: "https://www.linkedin.com/company/107867969/admin/",
    youtube: "https://www.youtube.com/@Dentistinbloomingdale",
  },

  // Open Dental Configuration
  defaultProvNum: 1,
  defaultOpNum: 11,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: 'New patient emergency/other',
      label: 'New patient emergency/other',
      duration: 30,
      opNum: 9,
      AppointmentTypeNum: 14
    },
    {
      value: 'Existing patient emergency/other',
      label: 'Existing patient emergency/other',
      duration: 30,
      opNum: 11,
      AppointmentTypeNum: 17
    },
    {
      value: 'Existing patient current treatment Plan',
      label: 'Existing patient current treatment Plan',
      duration: 30,
      opNum: 11,
      AppointmentTypeNum: 12
    }
  ],

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:${this.phoneNumberRaw}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;

